import { render } from "./ProjectGrid.vue?vue&type=template&id=41049215&scoped=true"
import script from "./ProjectGrid.vue?vue&type=script&lang=js"
export * from "./ProjectGrid.vue?vue&type=script&lang=js"

import "./ProjectGrid.vue?vue&type=style&index=0&id=41049215&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41049215"]])

export default __exports__